import React from "react";
import { useDisableBodyScroll } from "../utils/useDisableBodyScroll";

function Loading({ active, message }) {

  useDisableBodyScroll(active)

  return active ? (
    <div id="overlay" className="text-center overlay">
      <div className="overlay-content" style={{ '--color': 'white' }}>
        <div>
          <h2 className="text-uppercase color-white">{message}</h2>
          <LoadingIcon />
        </div>
      </div>
    </div>
  ) : null;
}

export default Loading;

export function LoadingIcon() {
  return (
    <div className="loadingio-spinner-spinner-on3qiy71xv">
      <div className="ldio-uq9qng4dkvl">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}
